import { find as _find } from 'lodash';
import { without as _without } from 'lodash';
import { filter as _filter } from 'lodash';

class ListController {
  constructor(entityService, $timeout, loadingService, $window, authService, enums) {
    "ngInject";

    this.entityService = entityService;
    this.$timeout = $timeout;
    this.loadingService = loadingService;
    this.$window = $window;
    this.authService = authService;
    this.enums = enums;

    this.reset();
  }

  reset() {
    this.filterParams = {
      entityType: '0',
      state: '0',
      brandType: '0',
      sortExpression: 'entityType',
      ascending: true
    };

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    this.notification = {
      type: 'info',
      msg: ''
    };

    this.listEntities();
  }

  updateSort(fieldName) {
    if (this.filterParams.sortExpression === fieldName) {
      this.filterParams.ascending = !this.filterParams.ascending;
    }
    else {
      this.filterParams.sortExpression = fieldName;
      this.filterParams.ascending = true;
    }

    this.listEntities();
  }

  listEntities() {
    const listCtrl = this;
    const pageIndex = this.getPageIndex();

    this.loadingService.showLoading('entityListing', 'Loading Entities ...');

    listCtrl.entityService.listEntities(listCtrl.filterParams, pageIndex, listCtrl.pagination.pageSize)
      .then(response => {
        response.data.items.map(entity => listCtrl.getActionsDropdown(entity));
        listCtrl.entities = response.data.items;
        listCtrl.pagination.totalItems = response.data.totalRecords;

        if (listCtrl.pagination.totalItems === 0) {
          listCtrl.notification = {
            type: 'info',
            msg: `No data to display`
          }
        } else {
          const pageEnd = (pageIndex + listCtrl.pagination.pageSize) < response.data.totalRecords ? (pageIndex + listCtrl.pagination.pageSize) :  response.data.totalRecords;

          listCtrl.notification = {
            type: 'info',
            msg: `Currently display ${(pageIndex+1)} to ${pageEnd} out of ${listCtrl.pagination.totalItems} records`
          }
        }
      })
      .catch(err => {
        listCtrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching entities." + (err.data ? err.data.messageDetail : '')
        }
      })
      .finally(() => {
        this.loadingService.hideLoading('entityListing');
      });
  }

  getPageIndex() {
    if (this.pagination.currentPage === 1) {
      return 0;
    }
    else {
      return ((this.pagination.currentPage-1) * this.pagination.pageSize);
    }
  }

  getActionsDropdown(entity) {
    let actions = [];
    const {entityType, entityId, name, state} = entity;

    switch(entityType) {
      case 1:
        if(this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Edit, false)) {
          actions.push({text: 'Edit Company', sref:'admin.entity.edit({entityType: ' + entityType + ', entityId: ' + entityId + '})'});
        }

        if(this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Add, false)) {
          actions.push({text: 'Add Child Company', sref:'admin.entity.add({entityType: 1 , parent: {entityId: ' + entityId + ', entityName: "' + name + '"}})'});
        }

        if(this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Add, false)) {
          actions.push({text: 'Add Dealer', sref:'admin.entity.add({entityType: 2 , parent: {entityId: ' + entityId + ', entityName: "' + name + '"}})'});
        }
        break;

      case 2:
        if(this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Edit, false)) {
          actions.push({text: 'Edit Dealer', sref:'admin.entity.edit({entityType: ' + entityType + ', entityId: ' + entityId + '})'});
        }

        if(this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Add, false)) {
          actions.push({text: 'Add Location', sref:'admin.entity.add({entityType: 3 , parent: {entityId: ' + entityId + ', entityName: "' + name + '"}})'});
        }
        break;

      case 3:
        if(this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Edit, false)) {
          actions.push({text: 'Edit Location', sref:'admin.entity.edit({entityType: ' + entityType + ', entityId: ' + entityId + '})'});
        }
        break;
    }

    entity.actions = actions;
  }

  deleteEntity(entityId) {
    let sure, state;

    sure = this.$window.confirm(`Deleting an Entity will delete the Entity and all its child entities. Are you sure you want to delete this entity ?`)

    if (!sure) {
      return;
    }

    this.loadingService.showLoading('entityListing', 'Removing Entity ...');

    this.updateEntityState(entityId, this.enums.OBJECT_ROW_STATE.Deleted);
  }

  suspendEntity(entityId) {
    let sure, state;

    sure = this.$window.confirm(`Suspending an Entity will suspend this Entity and all its child entities. Are you sure you want to suspend this entity ?`)

    if (!sure) {
      return;
    }

    this.loadingService.showLoading('entityListing', 'Suspending Entity ...');

    this.updateEntityState(entityId, this.enums.OBJECT_ROW_STATE.Inactive);
  }

  resumeEntity(entityId) {
    let sure, state;

    sure = this.$window.confirm(`Are you sure you want to resume this entity ?`)

    if (!sure) {
      return;
    }

    this.loadingService.showLoading('entityListing', 'Resuming Entity ...');

    this.updateEntityState(entityId, this.enums.OBJECT_ROW_STATE.Active);
  }

  updateEntityState(entityId, state) {
    const ctrl = this;

    ctrl.entityService.updateEntityState(entityId, state)
      .then(response => {
        ctrl.listEntities();
      })
      .catch(err => {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while updating entity state. " + err.data.messageDetail ? err.data : err.data.messageDetail
        }
      })
      .finally(() => {
        this.loadingService.hideLoading('entityListing');
      });
  }
}

export default ListController;



// WEBPACK FOOTER //
// ./client/app/components/admin/entity/list/list.controller.js